import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row } from "react-bootstrap";
import { useAuth } from "../../context/AuthContext";
import { formatDateTime } from "../../commons/FormatValue";
import { FloatingControlComponent } from "../FormComponent";
import Table from "../Table";
import PrintButton from "../PrintButton";
import ReportHeadComponent from "../ReportHeadComponent";
import CardDisplayComponent from "../CardDisplayComponent";

const PreviewRepairNotification = () => {
  const navigate = useNavigate();
  const canvasRef = useRef();
  const { user } = useAuth();
  const currentDate = new Date().toISOString();
  const inputField = {
    headerForm: [
      { name: "", label: "เลขที่แจ้งซ่อม", size: 12 },
      { name: "", label: "วันที่รับแจ้งซ่อม", size: 6 },
      { name: "", label: "เวลา", size: 6 }
    ],
    mainForm: [
      { name: "", label: "อ้างอิง Ticket (ลูกค้า)", size: "1_5" },
      { name: "", label: "อ้างอิงวันที่แจ้ง(ลูกค้า)", size: "1_5" },
      { name: "", label: "ประเภทงาน" },
      { name: "", label: "ประเภทงานย่อย" },
      { name: "", label: "ช่องทางรับเรื่อง" },
      { name: "", label: "รหัสลูกค้า" },
      { name: "", label: "ชื่อลูกค้า", size: 6 },
      { name: "", label: "เลขโครงการ", size: "1_5" },
      { name: "", label: "Service Call", size: "1_5" },
      { name: "", label: "ที่อยู่", size: 6 },
      { name: "", label: "ผู้ติดต่อ 1" },
      { name: "", label: "เบอร์ติดต่อ 1" },
      { name: "", label: "รหัสสาขา", size: "1_5" },
      { name: "", label: "เลขที่สาขา", size: "1_5" },
      { name: "", label: "ชื่อสาขา" },
      { name: "", label: "ผู้ติดต่อ 2" },
      { name: "", label: "เบอร์ติดต่อ 2" },
      { name: "", label: "ที่อยู่", size: 9 },
      { name: "", label: "E-Mail" },
      { name: "", label: "ธุรการผู้รับผิดชอบแบรนด์" },
      { name: "", label: "ชื่อทีม/หัวหน้าช่าง", size: 6 },
      { name: "", label: "สถานะงานใบแจ้งงาน" }
    ],
    workPM: [
      { name: "", label: "เงื่อนไขในการทำงาน" },
      { name: "", label: "งานที่มี PM/ไม่มี PM (ในเดือน)" },
      { name: "", label: "เลขที่ใบสั่งงาน" }
    ],
    employee: [
      { name: "", label: "ผู้รับแจ้ง", value: user.username },
      {
        name: "",
        label: "ผู้จ่ายงาน (FVC)",
        value: formatDateTime(currentDate)
      },
      { name: "", label: "ผู้อนุมัติ" }
    ]
  };
  const columns = [
    { name: "ลำดับ", selector: (row) => row.rowIndex, width: "110px" },
    { name: "รหัสอุปกรณ์", selector: (row) => row.Item?.Item_Code },
    { name: "รายละเอียดอุปกรณ์", selector: (row) => row.Item?.Item_Name_TH },
    { name: "อาการที่ได้รับแจ้ง", selector: (row) => row.Inform_Des },
    { name: "จน.ชม.ช่างทำงาน (DT)", selector: (row) => row },
    { name: "วัน/เวลา/ครบกำหนด", selector: (row) => row }
  ];

  return (
    <>
      <PrintButton
        componentRef={canvasRef}
        button={{ style: { zIndex: 10, top: "100px", right: "50px" } }}
      />

      <div ref={canvasRef}>
        <CardDisplayComponent
          cardClassName="px-5"
          header={{
            className: "mx-5 px-2",
            title: {
              className: "mx-2_5 text-center",
              text: "แสดงและพิมพ์ใบแจ้งซ่อม"
            }
          }}
          body={{
            className: "mx-5 px-2",
            element: (
              <>
                <Row className="mx-2_5">
                  <Col
                    sm={9}
                    className="ReportHead mb-3 d-flex align-items-center"
                  >
                    <ReportHeadComponent formName="REPAIR NOTIFICATION FORM" />
                  </Col>

                  <Col as={Row} sm={3} className="ms-0 px-0">
                    {inputField.headerForm.map(({ name, label, size }, idx) => (
                      <Col key={`header-${idx}`} sm={size} className="mb-3">
                        <FloatingControlComponent
                          disabled
                          name={name}
                          label={label}
                          className={{ label: "mb-1" }}
                        />
                      </Col>
                    ))}
                  </Col>
                </Row>

                <Row className="mx-2_5">
                  {inputField.mainForm.map(({ name, label, size }, idx) => (
                    <Col
                      key={`main-${idx}`}
                      sm={size === null ? null : size ?? 3}
                      className={
                        idx < inputField.mainForm.length - 3 ? "mb-3" : ""
                      }
                    >
                      <FloatingControlComponent
                        disabled
                        name={name}
                        label={label}
                        className={{
                          label:
                            idx < inputField.mainForm.length - 3 ? "mb-1" : ""
                        }}
                      />
                    </Col>
                  ))}
                </Row>
              </>
            )
          }}
        />

        <CardDisplayComponent
          cardClassName="px-5"
          header={{
            className: "mx-5 px-2",
            title: {
              className: "mx-2_5 px-2_75",
              text: "รายละเอียดอุปกรณ์ที่แจ้งซ่อม"
            }
          }}
          body={{
            className: "mx-5 px-2",
            element: (
              <div className="mx-2_5 px-2_75">
                <Table data={[]} column={columns} searchFilter={[]} />
              </div>
            )
          }}
        />

        <CardDisplayComponent
          cardClassName="px-5"
          body={{
            className: "mx-5 px-2",
            element: (
              <div className="mx-2_5 px-2_75">
                <FloatingControlComponent
                  disabled
                  name=""
                  label="คำสั่งเพิ่มเติม (ลูกค้า)"
                />
              </div>
            )
          }}
        />

        <CardDisplayComponent
          cardClassName="px-5"
          body={{
            className: "mx-5 px-2",
            element: (
              <div className="mx-2_5 px-2_75">
                <FloatingControlComponent
                  disabled
                  name=""
                  label="ข้อมูลที่ได้รับแจ้ง (ลูกค้า)"
                />
              </div>
            )
          }}
        />

        <CardDisplayComponent
          cardClassName="px-5"
          body={{
            className: "mx-5 px-2",
            element: (
              <Row className="mx-2_5">
                {inputField.workPM.map(({ name, label }, idx) => (
                  <Col key={`workPM-${idx}`} sm={4}>
                    <FloatingControlComponent
                      disabled
                      name={name}
                      label={label}
                    />
                  </Col>
                ))}
              </Row>
            )
          }}
        />

        <CardDisplayComponent
          cardClassName="px-5"
          body={{
            className: "mx-5 px-2",
            element: (
              <Row className="mx-2_5">
                {inputField.employee.map(({ name, label, value }, idx) => (
                  <Col key={`employee-${idx}`} sm={4}>
                    <FloatingControlComponent
                      disabled
                      name={name}
                      label={label}
                      value={value}
                    />
                  </Col>
                ))}
              </Row>
            )
          }}
          footer={{
            className: "text-center mx-5 px-2",
            element: (
              <Button
                variant="outline-secondaery"
                className="px-4 py-2 text-dark border-secondary rounded-pill"
                onClick={() => navigate(-1)}
              >
                ย้อนกลับ
              </Button>
            )
          }}
        />
      </div>
    </>
  );
};

export default PreviewRepairNotification;
